<app-nav class="w-100"></app-nav>
<section class="banner">
    <app-home-searchbar [ous]="licenseOus" [pageLoading]="pageLoading"></app-home-searchbar>
</section>

<section *ngIf="pageLoading; else entitiesReady">
    <app-home-entities [placeholder]="true"></app-home-entities>
</section>
<ng-template #entitiesReady>
    <section *ngIf="permissionService.hasPermission('CONTENT','r') || (!isLoggedIn && hasContentDefaultPermisssion())">
        <app-home-entities (licenseOus)="licenseOus = $event"></app-home-entities>
    </section>
</ng-template>

<!-- <section class="home-banner-height">
    <app-home-otherpages></app-home-otherpages>
</section> -->
<p-dialog 
    [blockScroll]="true" [draggable]="false" [closable]="closable && !startQuiz" [modal]="true"
    [header]="announcements && announcements.title"
    [maximizable]="true" [(visible)]="showAnnouncement" (onHide)="setAnnouncementSeenBy(announcements?._id);"
    
    [style]="{ width:'95vw', maxWidth:'1000px',maxHeight:'700px'}">
    <div class="text-center">
        <img *ngIf="announcements && announcements?.image"
            class="img-fluid text-center border border-secondary rounded border-opacity-50 radius-2"
            [style]="{ maxHeight: '400px'}" [src]="staticURL + announcements?.image">
        <p class="annoucementDiv my-3" [innerHTML]="announcements && announcements.description | safeHTML"></p>
    </div>

    <div *ngIf="assessment">
        <div *ngIf="!startQuiz" class="w-100 text-center d-flex flex-row align-items-center justify-center justify-items-center justify-content-center gap-2">
            <button class="v4-btn-every m-1"
                (click)="startQuiz=true"><i class="pi pi-check m-l-2"></i>{{'Click here to start the exam' | translator}}</button>
            <button class="v4-btn-every m-1" *ngIf="closable"
                (click)="showAnnouncement=false"><i class="pi pi-times m-l-2"></i>{{'I will do it later' | translator}}</button>
                <!-- <p-button class="" label=" {{'Click here to start the exam' | translator}} " [icon]="'pi pi-check'"
                (onClick)="startQuiz=true"></p-button>
            <p-button class="" *ngIf="closable" label=" {{'I will do it later' | translator}} " [icon]="'pi pi-times'"
                (onClick)="showAnnouncement=false"></p-button> -->
        </div>

        <div *ngIf="startQuiz">

            <app-popupview-questions [(currentQuestion)]="assessment.questions"></app-popupview-questions>
            <p-messages [(value)]="messages" [enableService]="false"></p-messages>
            <div class="w-100 text-center d-flex flex-column align-items-center">
                <button class="v4-btn-every"
                    (click)="assessmentSubmit()"><i class="pi pi-checkboxValue m-l-2"></i>{{'Submit Answers' | translator}}</button>
            </div>


        </div>

        <div *ngIf="!closable" class="w-100 text-center d-flex flex-column align-items-center">
            <small class="mt-2 alert alert-danger px-4 py-2" role="alert">{{'you have already closed this quiz ' | translator}} {{ignoreCount}}
                {{ 'times. 1' | translator}} {{'You are not allowed to skip this if you have skipped this quiz ' | translator}}
                {{announcements?.ignoreLimit}} {{'times from now' | translator}}.</small>
        </div>
        
        
    </div>

   

</p-dialog>

<app-popup-tutorial [display]="false"></app-popup-tutorial>

<section class="access" *ngIf="isLoggedIn">
    <div class="access-inner">
        <h2 class="access-heading">يمكنك الوصول إلى</h2>

        <div class="access-grid">
            <div *ngFor="let product of products" class="access-card" role="button" tabindex="0"
                (click)="navigateToRoute(product.route)" (keydown.enter)="navigateToRoute(product.route)">
                <img [src]="product.image" [alt]="product.name" class="access-image" />
                <div class="access-body">
                    <h3 class="access-title">{{ product.name }}</h3>
                    <p class="access-desc">{{ product.description }}</p>
                    <span class="access-link">
                        <span>استعرض</span>
                        <i class="pi pi-angle-left"></i>
                    </span>
                </div>
            </div>
        </div>
    </div>
</section>
<app-footer></app-footer>